import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { ServiceGroupRate } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromServiceGroupRates from './service-group-rate.actions';
import { ServiceGroupRatesState } from './service-group-rate.interfaces';
import { map } from 'rxjs/operators';
@Injectable()
export class ServiceGroupRatesEffects {
  
  getServiceGroupRatesFromServer = createEffect(() => this.dataPersistence.fetch(
    fromServiceGroupRates.GET_SERVICE_GROUP_RATES_FROM_SERVER,
    {
      run: (action: fromServiceGroupRates.GetServiceGroupRatesFromServer, state: ServiceGroupRatesState) => {
        return this.apiService
          .get<ServiceGroupRate[]>(`v/1/fixed-operations/service-group-rates`, {
            params: action.payload
          })
          .pipe(
            map(
              serviceGroupRates =>
                new fromServiceGroupRates.GetServiceGroupRatesFromServerSuccess({
                  serviceGroupRates: serviceGroupRates
                })
            )
          );
      },
      onError: (action: fromServiceGroupRates.GetServiceGroupRatesFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ServiceGroupRatesState>,
    private apiService: ApiService
  ) {}
}
